import { createFileRoute } from "@tanstack/react-router";

import { ForgotPasswordPage } from "@/components/auth/forgot-password-page";

export const Route = createFileRoute("/_auth/_anonymous/forgot-password")({
  component: () => <ForgotPasswordPage />,
});
